// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"19351":"a5ce6a92","46832":"c42ece5b"}[chunkId] || chunkId) + "." + {"11417":"21e11424e0420983","19351":"ab7e97a748699ec2","46832":"5a2abdfd83fc2dcd","53348":"203867af16d1c7ee","72965":"8c8bdbb4740104a6","81529":"84c435a0fc894105","98084":"7e5eadab849df2cc"}[chunkId] + ".js";
};